import IColumnData from "../../../../common/interface/IColumnData";

export const FACTURA_COLUMN :IColumnData[] = [    
    {
        width: 120,
        label: 'NRO. DOCUMENTO',
        dataKey: 'documento',
    },
    {
        width: 80,
        label: 'TIPO DE DOCUMENTO',
        dataKey: 'tipo'
    },
    {
        width: 40,
        label: 'IMPORTE',
        dataKey: 'importe',
        numeric: true,
    },
    {
        width: 40,
        label: 'MONEDA',
        dataKey: 'moneda',
    },
    {
        width: 20,
        label: 'FECHA DE EMISIÓN',
        dataKey: 'fechaEmision'
    },
    {
        width: 40,
        label: 'COMPROBANTE',
        dataKey: 'tienePdf',
        boolean: true
    }
];